import { render, staticRenderFns } from "./CropProfilesPage.vue?vue&type=template&id=31638ab5&scoped=true&"
import script from "./CropProfilesPage.vue?vue&type=script&lang=js&"
export * from "./CropProfilesPage.vue?vue&type=script&lang=js&"
import style0 from "./CropProfilesPage.vue?vue&type=style&index=0&id=31638ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31638ab5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VCard,VContainer,VFlex,VLayout})
